import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';
import 'swiper/css/effect-fade';

document.addEventListener('DOMContentLoaded', () => {
    const testimonialSections = document.querySelectorAll('.testimonial-component');

    testimonialSections.forEach(section => {
        const leftEl = section.querySelector('.testimonial-swiper-left');
        const rightEl = section.querySelector('.testimonial-swiper-right');
        const prevBtn = section.querySelector('.swiper-button-prev');
        const nextBtn = section.querySelector('.swiper-button-next');

        if (!leftEl) {return;}

        // ✅ Left Swiper with Fade
        const leftSwiper = new Swiper(leftEl, {
            slidesPerView: 1,
            speed: 600,
            loop: false,
            effect: 'fade',
            fadeEffect: { crossFade: true },
            allowTouchMove: false,
            autoHeight: true,
            navigation: {
                nextEl: nextBtn,
                prevEl: prevBtn,
            },
        });

        let rightSwiper;
        if (rightEl && rightEl.querySelectorAll('.swiper-slide').length > 0) {
            // ✅ Right Swiper with Fade
            rightSwiper = new Swiper(rightEl, {
                slidesPerView: 1,
                speed: 600,
                effect: 'fade',
                fadeEffect: { crossFade: true },
                allowTouchMove: false,
                loop: false,
                autoHeight: true,
            });

            // ✅ Sync both sliders
            leftSwiper.on('slideChange', () => {
                rightSwiper.slideTo(leftSwiper.activeIndex);
            });
        } else {
            // ✅ If no right slider, make left full width
            section.querySelector('.testimonial-slider-wrap').classList.add('no-right-slider');
        }
    });

    // ✅ Add class if blank slide exists
    const rightSwiper = document.querySelector('.testimonial-swiper-right');
    if (rightSwiper && rightSwiper.querySelector('.blank-slide')) {
        rightSwiper.classList.add('has-blank-slide');
    }
});
